// Blocked IP ranges (RFC 1918, localhost, link-local, AWS metadata)
const BLOCKED_PATTERNS = [
    /^localhost$/i,
    /^127\.\d+\.\d+\.\d+$/,
    /^10\.\d+\.\d+\.\d+$/,
    /^172\.(1[6-9]|2\d|3[01])\.\d+\.\d+$/,
    /^192\.168\.\d+\.\d+$/,
    /^169\.254\.\d+\.\d+$/, // link-local
    /^0\.0\.0\.0$/,
    /^::1$/,
    /^fc00:/i,
    /^fe80:/i,
    /^fd/i,
];
// AWS metadata endpoint
const BLOCKED_HOSTS = ['169.254.169.254', 'metadata.google.internal'];
export function validateTargetUrl(input) {
    let urlString = input.trim();
    // Add protocol if missing
    if (!urlString.match(/^https?:\/\//i)) {
        urlString = `https://${urlString}`;
    }
    let url;
    try {
        url = new URL(urlString);
    }
    catch {
        return {
            valid: false,
            error: 'This doesn\'t look like a valid URL. Try something like "example.com" or "https://mysite.com".',
        };
    }
    // Only allow http/https
    if (!['http:', 'https:'].includes(url.protocol)) {
        return {
            valid: false,
            error: 'Only HTTP and HTTPS URLs are supported.',
        };
    }
    const hostname = url.hostname.toLowerCase();
    // Check blocked hosts
    if (BLOCKED_HOSTS.includes(hostname)) {
        return {
            valid: false,
            error: 'This URL points to an internal service and cannot be scanned.',
        };
    }
    // Check blocked IP patterns
    for (const pattern of BLOCKED_PATTERNS) {
        if (pattern.test(hostname)) {
            return {
                valid: false,
                error: 'Internal and private IP addresses cannot be scanned. Please provide a public URL.',
            };
        }
    }
    // Must have a valid TLD (basic check)
    if (!hostname.includes('.') && hostname !== 'localhost') {
        return {
            valid: false,
            error: 'Please provide a full domain name like "example.com".',
        };
    }
    return {
        valid: true,
        normalizedUrl: url.toString(),
    };
}
//# sourceMappingURL=url.js.map